import React from 'react'
import './footer.scss'
export default function Footer() {
  return (
    <div className='footer'>&#169; All Right Reserved, Shri Onkarlal Nursing Mahavidlaya 2024.</div>
  )
}
